import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-hint',
  styleUrl: 'a1-hint.scss',
  scoped: true,
})
export class A1Hint {
  /**
   * Text for the hint.
   */
  @Prop({ reflect: true }) text!: string;

  /**
   * Define the hint state.
   */
  @Prop({ reflect: true }) state: 'resting' | 'disabled' = 'resting';

  render() {
    return <p class={`hint ${this.state}`}>{this.text}</p>;
  }
}
